<template>
  <v-radio
    v-bind="{
      ...$attrs,
      ...commonAttrs
    }"
    v-on="$listeners"
  >
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="data">
      <slot :name="scopedSlotName" v-bind="data"/>
    </template>

    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName"/>
    </template>
  </v-radio>
</template>

<script>
export default {
  name: 'x-radio',
  computed: {
    commonAttrs() {
      return {
        color: this.$attrs.color ?? '#24C4A3',
        ripple: this.$attrs.ripple ?? false,
        onIcon: this.$attrs.onIcon ?? '$radioOn',
        offIcon: this.$attrs.offIcon ?? '$radioOff'
      }
    }
  }
}
</script>

<style scoped>

</style>